import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Business } from "../../../views/common/messages";
import { CancelButton } from "../../../views/common-forms/components";
import { StampInfoText } from "./Messages";
import TimeStampButton from "./TimeStampButton";
import { SelectDirectionProps, StampDirection } from "../../../shared/timeclock/models";
import { isPrimaryDirectionIn, isPrimaryDirectionOut, isChangeDirectionAvailable } from "../../../shared/timeclock/functions/stampDirectionHelpers";
import { ReactElement } from "react";

const maybeQuote = (quote: boolean, msg: string) => quote ? `(${msg})` : msg;

export const SelectDirection = ({ person, onClick, cancelClick }: SelectDirectionProps): ReactElement => {

    const offlineOrTemp = (!person.stampInStatus && !person.stampOutStatus) || person.personName === "<?> <?>";
    const emplNoSuffix = maybeQuote(!offlineOrTemp, person.employeeNumber);

    return (
        <div className="stampform">
            <p className="tc-message-box">
                {offlineOrTemp ? <FormattedMessage {...Business.Code} /> : person.personName} {emplNoSuffix}
                <br />
                <StampInfoText person={person} />
            </p>
            <div className="stampform-flex">
                <TimeStampButton onClickHandler={onClick} direction={StampDirection.In} primary={isPrimaryDirectionIn(person.lastStamp)} />
                <TimeStampButton onClickHandler={onClick} direction={StampDirection.Out} primary={isPrimaryDirectionOut(person.lastStamp)} />
                <div hidden={!person.hasBalance} className="stampform-footer">
                    <TimeStampButton onClickHandler={onClick} direction={StampDirection.Balance} primary={isPrimaryDirectionOut(person.lastStamp)} />
                </div>
                {isChangeDirectionAvailable(person)
                    ? <TimeStampButton onClickHandler={onClick} direction={StampDirection.Change} primary={false} />
                    : null}
                <CancelButton onClick={cancelClick} />

            </div>

        </div>
    );
};
